import React, { useState, useEffect } from "react";
import Card from "react-bootstrap/Card";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";

import FormikContainer from "../../../components/form/FormikContainer.jsx";
import genericTranslations from "../../../utils/genericTranslations.js";
import { validateEmailAddress } from "../../../utils/utils.js";
import { selectEstablishmentById } from "../selectors";
import { fetchEstablishmentById, saveEstablishment } from "../thunks.js";

import EstablishmentForm from "./EstablishmentForm.jsx";

const messages = {
  establishment: {
    id: "modules.EmailAddressEstablishment.components.EstablishmentEditor.establishment",
    description: "Establishment label.",
    defaultMessage: "Establishment",
  },
  notFoundMessage: {
    id: "modules.EmailAddressEstablishment.components.EstablishmentEditor.notFoundMessage",
    description: "Error message fetching the establishment",
    defaultMessage: "Couldn't find the email adress establishment!",
  },
};

const EstablishmentEditor = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { identifier } = useParams();

  const [error, setError] = useState();

  const establishment = useSelector((state) =>
    selectEstablishmentById(state, { identifier }),
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        await dispatch(fetchEstablishmentById(identifier));
      } catch (err) {
        setError(err);
      }
    };

    if (identifier && !establishment) {
      fetchData();
    }
  }, [establishment, identifier, dispatch]);

  const handleSubmit = async (values, { setSubmitting }) => {
    setSubmitting(true);

    try {
      await dispatch(
        saveEstablishment(
          values,
          establishment ? establishment.id : undefined,
          establishment ? establishment.principalId : undefined,
        ),
      );
      navigate("/email-establishment", { replace: true });
    } catch (err) {
      setError(`Er ging iets fout bij het opslaan: ${err}`);
    } finally {
      setSubmitting(false);
    }
  };

  const validate = (values) => {
    const errors = {};
    const required = ["emailAddress"];
    required.forEach((k) => {
      if (!values[k]) errors[k] = "Verplicht";
    });
    if (values.emailAddress && validateEmailAddress(values.emailAddress)) {
      errors.emailAddress = "Geen geldig e-mailadres";
    }
    return errors;
  };

  if (error) {
    return (
      <strong>{intl.formatMessage(genericTranslations.errorMessage)} </strong>
    );
  }

  if (!establishment && identifier) {
    return <strong>{intl.formatMessage(messages.notFoundMessage)}</strong>;
  }

  return (
    <Card>
      <Card.Header className="card-header-borderless" as="h3">
        {intl.formatMessage(messages.establishment)}{" "}
        {establishment
          ? intl.formatMessage(genericTranslations.edit).toLowerCase()
          : intl.formatMessage(genericTranslations.add).toLowerCase()}
      </Card.Header>
      <Card.Body>
        <FormikContainer
          initialValues={establishment || {}}
          onSubmit={handleSubmit}
          validate={validate}
          formComponent={EstablishmentForm}
        />
      </Card.Body>
    </Card>
  );
};

export default EstablishmentEditor;
